import React from 'react';
import { motion } from 'framer-motion';

const FloatingElements = () => {
  const elements = [
    { size: 300, x: '10%', y: '20%', delay: 0, duration: 20, color: 'from-violet-500/20 to-blue-500/10' },
    { size: 200, x: '80%', y: '30%', delay: 2, duration: 25, color: 'from-blue-500/15 to-indigo-500/10' },
    { size: 250, x: '70%', y: '70%', delay: 4, duration: 22, color: 'from-purple-500/20 to-violet-500/10' },
    { size: 180, x: '20%', y: '80%', delay: 1, duration: 28, color: 'from-indigo-500/15 to-blue-500/10' },
    { size: 150, x: '50%', y: '10%', delay: 3, duration: 18, color: 'from-violet-600/20 to-purple-500/10' },
    { size: 220, x: '90%', y: '90%', delay: 5, duration: 24, color: 'from-blue-600/15 to-violet-500/10' },
  ];

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {elements.map((el, index) => (
        <motion.div
          key={index}
          className={`absolute rounded-full bg-gradient-to-br ${el.color} blur-3xl`}
          style={{
            width: el.size,
            height: el.size,
            left: el.x,
            top: el.y,
          }}
          animate={{
            x: [0, 50, -30, 20, 0],
            y: [0, -40, 30, -20, 0],
            scale: [1, 1.1, 0.9, 1.05, 1],
          }}
          transition={{
            duration: el.duration,
            delay: el.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default FloatingElements;
